import fetch from 'isomorphic-fetch'
import {pendingTask, begin, end} from 'react-redux-spinner'
import {EVENT_LIST_REQUEST, EVENT_LIST, EVENT_LIST_ERROR} from './types'

export function fetchEventsFail(error) {
  const data = {
    error,
    loading: false,
  }
  return {
    type: EVENT_LIST_ERROR,
    [pendingTask]: end,
    payload: data,
  }
}

export function fetchEventsRequest() {
  const data = {
    loading: true,
  }
  return {
    type: EVENT_LIST_REQUEST,
    [pendingTask]: begin,
    payload: data,
  }
}

export function fetchEventsSuccess(events) {
  const data = {
    loading: false,
    events,
  }
  return {
    type: EVENT_LIST,
    [pendingTask]: end,
    payload: data,
  }
}

export default function fetchEvents() {
  return dispatch => {
    dispatch(fetchEventsRequest())
    return fetch(`${process.env.REACT_APP_EF_API_URL}/events/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: localStorage.getItem('token'),
      },
    })
      .then(res => res.json())
      .then(json => {
        dispatch(fetchEventsSuccess(json.events))
      })
      .catch(error => dispatch(fetchEventsFail(error)))
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/event_list.js
 **/